
import Attachment from "../../../components/drag_and_drop/Attachment/Attachment.vue";
import * as XLSX from 'xlsx';

export default {

  components: {
    Attachment
  },

  data() {
    return {
      tab: null,
      items: [
        { tab: 'Suscripciones', content: 'man_sus' },
        { tab: 'Rangos de Fechas', content: 'man_fec' },
        { tab: 'Recargo en pagos', content: 'rec_pag' },
        { tab: 'Suscripciones Gestor', content: 'man_ges_susp' },
      ],

      search: '',
      columnasSuscripciones: [
        {
          text: 'Nombre',
          align: 'start',
          sortable: true,
          value: 'nombre',
        },
        {
          text: 'Descripción',
          align: 'start',
          sortable: true,
          value: 'descripcion',
        },
        {
          text: 'Precio',
          align: 'start',
          sortable: true,
          value: 'precio',
        },
        {
          text: '¿Es anual?',
          align: 'start',
          sortable: true,
          value: 'anual',
        },
        {
          text: 'Modificar',
          align: 'start',
          sortable: false,
          value: 'acciones',
        },
      ],

      listadoSuscripcion: [],

      dialogSuscripciones: false,
      item_aux: null,

      conf_precio: {
        value: "1234567.89",
        label: "Precio de la suscripción",
        readonly: false,
        disabled: false,
        outlined: false,
        clearable: false,
        options: {
          locale: "en-US",
          prefix: "Q. ",
          suffix: "",
          length: 9,
          precision: 2
        },


      },

      conf_limite: {
        value: "1234567.89",
        label: "Límite de notificación",
        readonly: false,
        disabled: false,
        outlined: false,
        clearable: false,
        options: {
          locale: "en-US",
          prefix: "Q. ",
          suffix: "",
          length: 9,
          precision: 2
        },
      },

      form: {
        id: -1,
        nombre: '',
        descripcion: '',
        precio: '',
        anual: null,
      },

      deafult_form: {
        id: -1,
        nombre: '',
        descripcion: '',
        precio: '',
        anual: null,
      },

      listadoAnual: [{ text: "SI", value: 1 }, { text: "NO", value: 0 }],

      loading_suscripcion: false,
      loading_boton_suscripcion: false,
      loading_fechas: false,
      menu_fecha_ini: false,
      menu_fecha_fin: false,

      dias: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28],

      body_fecha: {
        dia_inicio: 0,
        dia_fin: 0,
        cantidad: 0,
      },

      dialog_consulta_listado_retenedores: false,

      actualiza_comision: '',

      dialogActualizarRecargo: false,

      loading_recargo: false,

      loading_cat_tipo_suscripcion_gestor: false,
      items_cat_tipo_suscripcion_gestor: [],
      columnas_cat_tipo_suscripcion_gestor: [
        {
          text: 'Nombre',
          align: 'start',
          sortable: true,
          value: 'nombre',
        },
        {
          text: 'Mínimo',
          align: 'start',
          sortable: true,
          value: 'min',
        },
        {
          text: 'Máximo',
          align: 'start',
          sortable: true,
          value: 'max',
        },
        {
          text: 'Precio',
          align: 'start',
          sortable: true,
          value: 'precio',
        },
        {
          text: 'Acciones',
          align: 'start',
          sortable: false,
          value: 'acciones',
        }
      ],

      cat_tipo_suscripcion_gestor: {
        nombre: '',
        min: 0,
        max: 0,
        precio: 0,
      },

      dialogCatTipoSuscripcionGestor: false,

      isDeleteCatTipoSuscripcionGestor: false,


    }
  },

  async created() {
    await this.getTiposSuscripcion();
  },



  watch: {
    dialog_consulta_listado_retenedores(val) {
      val || this.cerarDialogRetenedores()
    },

    dialogDelete(val) {
      val || this.closeDelete()
    },
  },

  methods: {


    exportarExcel(tipo) {

      if (tipo === 'man_sus') {
        let data = XLSX.utils.json_to_sheet(this.listadoSuscripcion)
        const workbook = XLSX.utils.book_new()
        const filename = 'man_suscripciones';
        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`)
      } else if (tipo === 'con_ret') {
        let data = XLSX.utils.json_to_sheet(this.retenciones_cargadas)
        const workbook = XLSX.utils.book_new()
        const filename = 'consulta_retenedores';
        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`)
      }
      // let info = [];
      // this.filas_declaraciones.forEach(element => {

      //   let data = {
      //     NIT: element.nit,
      //     CLIENTE_A_PRESENTAR: element.nombre,
      //     NUMERO_FORMULARIO: element.numero_formulario,      
      //     PAGO_IMPUESTO: element.pago,
      //   }
      //   info.push(data);
      // });
      // console.log("info");
      // console.log(info);
      // let data = XLSX.utils.json_to_sheet(info)
      // const workbook = XLSX.utils.book_new()
      // const filename = 'declara_realizadas'+this.fecha;
      // XLSX.utils.book_append_sheet(workbook, data, filename)
      // XLSX.writeFile(workbook, `${filename}.xlsx`)
    },


    modificar_recargo() {
      this.dialogActualizarRecargo = true;
    },

    confirmar_modificar_recargo() {
      this.dialogActualizarRecargo = false;
      this.actualiza_comision = '';
      this.$toast.success("El recargo de pago de impuesto se actualizó con éxito")
    },

    convertirnumero(numero) {
      let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
      return dollarUSLocale.format(Math.abs(numero))
    },

    async seleccionTab(tipo) {
      console.log(tipo);
      if (tipo == 'man_fec') {
        await this.getRangosFecha();
      } else if (tipo == 'man_reg') {
        await this.getRegimenListado();
      } else if (tipo == 'man_ros') {
        await this.getTipoEmisor();
        await this.getEmisores();
      } else if (tipo == 'man_ges_susp') {
        await this.catTipoSuscripcionGestor();
      }
    },

    async getTiposSuscripcion() {
      try {
        this.loading_suscripcion = true;
        let r = await this.$store.state.services.administradorService.getTiposSuscripcion(1);
        console.log(r);
        this.loading_suscripcion = false;
        this.listadoSuscripcion = r.data.data;
      } catch (error) {
        console.log(error);
        this.loading_suscripcion = false;
        this.$toast.error("No es posible obtener los tipos de suscripcion")
      }
    },

    modificarSuscripcion(item) {
      console.log(item);
      this.dialogSuscripciones = true;
      this.item_aux = item;
      this.form.id = this.item_aux.id;
      this.form.nombre = this.item_aux.nombre;
      this.form.descripcion = this.item_aux.descripcion;
      this.form.precio = this.item_aux.precio;
      this.form.anual = this.item_aux.anual;
    },

    crearSuscripcion() {
      this.dialogSuscripciones = true;
      this.form.id = 0;
      this.form.descripcion = '';
      this.form.precio = 0;

    },

    async desactivarSuscripcion(item) {
      try {
        this.loading_boton_suscripcion = true;
        let r = await this.$store.state.services.administradorService.desactivarTipoSuscripcion({ id: item.id });
        console.log(r);
        this.loading_boton_suscripcion = false;
        this.limpiar_suscripcion();
      } catch (error) {
        console.log(error);
        this.loading_boton_suscripcion = false;
      }
    },

    async confirmarModificarSuscripcion() {
      try {
        this.loading_boton_suscripcion = true;
        this.form.regimen_id = 1;
        let r = await this.$store.state.services.administradorService.actualizarTipoSuscripcion(this.form);
        console.log(r);
        this.loading_boton_suscripcion = false;
        this.limpiar_suscripcion();
      } catch (error) {
        console.log(error);
        this.loading_boton_suscripcion = false;
      }
    },

    async confirmarCrearSuscripcion() {
      try {
        this.loading_boton_suscripcion = true;
        this.form.regimen_id = 1;
        let r = await this.$store.state.services.administradorService.insertarTipoSuscripcion(this.form)
        console.log(r);
        this.loading_boton_suscripcion = false;
        this.limpiar_suscripcion();
      } catch (error) {
        console.log(error);
        this.loading_boton_suscripcion = false;
        this.$toast.error("No es posible crear un tipo de suscripción")
      }
    },


    limpiar_suscripcion() {
      this.dialogSuscripciones = false;
      this.item_aux = null;
      this.form = Object.assign({}, this.deafult_form);
      this.getTiposSuscripcion();
    },



    async getRangosFecha() {
      try {
        this.loading_fechas = true;
        let r = await this.$store.state.services.administradorService.getRangosFecha();
        console.log(r);
        this.loading_fechas = false;
        this.body_fecha.dia_inicio = r.data.data.dia_inicio;
        this.body_fecha.dia_fin = r.data.data.dia_fin;
        this.body_fecha.cantidad = r.data.data.cantidad_personas;
      } catch (error) {
        console.log(error);
        this.loading_fechas = false;
        this.$toast.error("No es posible obtener los tipos de suscripcion")
      }
    },

    async putActualizarRangosFecha() {
      try {
        this.loading_boton_suscripcion = true;
        let r = await this.$store.state.services.administradorService.putActualizarRangosFecha(this.body_fecha);
        console.log(r);
        this.loading_boton_suscripcion = false;
        this.$toast.success("Rangos de fecha y cantidad de usuarios actualizado");
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible actualizar los rangos de fecha y cantidad de usuarios")
        this.loading_boton_suscripcion = false;
      }
    },


    async listadoCargasRetenedores() {
      try {
        this.loading_retenciones = true;
        let r = await this.$store.state.services.administradorService.listadoCargasRetenedores();
        console.log('retenedores cargados', r);
        r.data.data.filter(x => x.loading = false);
        this.retenciones_cargadas = r.data.data;
        this.loading_retenciones = false;
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible listar los retenerdores")
        this.loading_retenciones = false;
      }
    },

    cerarDialogRetenedores() {
      this.listado_retenedores = [];
    },

    createCatTipoSuscripcionGestor() {
      this.dialogCatTipoSuscripcionGestor = true;
      this.isDeleteCatTipoSuscripcionGestor = false;
    },

    updateCatTipoSuscripcionGestor(item) {
      this.isDeleteCatTipoSuscripcionGestor = false;
      this.dialogCatTipoSuscripcionGestor = true;
      this.cat_tipo_suscripcion_gestor = Object.assign({}, item);
    },

    deleteCatTipoSuscripcionGestor(item) {
      this.dialogCatTipoSuscripcionGestor = true;
      this.isDeleteCatTipoSuscripcionGestor = true;
      this.cat_tipo_suscripcion_gestor = Object.assign({}, item);
    },

    async catTipoSuscripcionGestor() {
      try {
        this.loading_suscripcion = true;
        let r = await this.$store.state.services.gestoresService.catTipoSuscripcionGestor();
        console.log(r);
        this.loading_suscripcion = false;
        this.items_cat_tipo_suscripcion_gestor = r.data.data;
      } catch (error) {
        console.log(error);
        this.loading_suscripcion = false;
        this.$toast.error("No es posible obtener los tipos de suscripcion")
      }
    },

    async confirmarCrearCatTipoSuscripcionGestor() {
      try {
        this.loading_boton_suscripcion = true;
        let r = await this.$store.state.services.gestoresService.catTipoSuscripcionGestorCreate(this.cat_tipo_suscripcion_gestor);
        console.log(r);
        this.loading_boton_suscripcion = false;
        this.cat_tipo_suscripcion_gestor = {
          nombre: '',
          min: 0,
          max: 0,
          precio: 0,
        };
        this.dialogCatTipoSuscripcionGestor = false;
        this.catTipoSuscripcionGestor();
      } catch (error) {
        console.log(error);
        this.loading_boton_suscripcion = false;
        this.$toast.error("No es posible crear un tipo de suscripción")
      }
    },

    async confirmarModificarCatTipoSuscripcionGestor() {
      try {
        this.loading_boton_suscripcion = true;
        let r = await this.$store.state.services.gestoresService.catTipoSuscripcionGestorUpdate(this.cat_tipo_suscripcion_gestor);
        console.log(r);
        this.loading_boton_suscripcion = false;
        this.cat_tipo_suscripcion_gestor = {
          nombre: '',
          min: 0,
          max: 0,
          precio: 0,
        };
        this.dialogCatTipoSuscripcionGestor = false;
        this.catTipoSuscripcionGestor();
      } catch (error) {
        console.log(error);
        this.loading_boton_suscripcion = false;
        this.$toast.error("No es posible modificar un tipo de suscripción")
      }
    },

    async confirmarEliminarCatTipoSuscripcionGestor() {
      try {
        this.loading_boton_suscripcion = true;
        let r = await this.$store.state.services.gestoresService.catTipoSuscripcionGestorDelete(this.cat_tipo_suscripcion_gestor);
        console.log(r);
        this.loading_boton_suscripcion = false;
        this.cat_tipo_suscripcion_gestor = {
          nombre: '',
          min: 0,
          max: 0,
          precio: 0,
        };
        this.dialogCatTipoSuscripcionGestor = false;
        this.catTipoSuscripcionGestor();
      } catch (error) {
        console.log(error);
        this.loading_boton_suscripcion = false;
        this.$toast.error("No es posible eliminar un tipo de suscripción")
      }
    },

    cancelarCatTipoSuscripcionGestor() {
      this.cat_tipo_suscripcion_gestor = {
        nombre: '',
        min: 0,
        max: 0,
        precio: 0,
      };
      this.dialogCatTipoSuscripcionGestor = false
      this.isDeleteCatTipoSuscripcionGestor = false;
    },
  }


}